<template>
    <div :class="{ 'no-break': noBreak }">
        <div class="d-flex align-items-center mb-2">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" :id="id" v-model="isEnabled" @change="handleToggle">
                <label class="form-check-label" :for="id">
                    {{ title }}
                </label>
            </div>
        </div>

        <div v-if="isEnabled">
            <h3 class="topic-title" v-if="isTopicTitle">{{ title }}</h3>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportSection',

    props: {
        id: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        isTopicTitle: {
            type: Boolean,
            default: false
        },
        noBreak: {
            type: Boolean,
            default: false
        },
        enabled: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            isEnabled: this.enabled
        };
    },

    methods: {
        handleToggle() {
            this.$emit('toggle', {
                id: this.id,
                enabled: this.isEnabled
            });
        }
    },

    watch: {
        enabled(newValue) {
            this.isEnabled = newValue;
        }
    }
};
</script>

<style scoped>
.form-check {
    margin-bottom: 0;
}

.form-check-label {
    font-weight: bold;
    color: #4bacc6;
    font-size: 16px;
    text-transform: uppercase;
}

.topic-title {
    background-color: #dbe5f1;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    padding: 32px;
    margin-bottom: 16px;
  }
</style>